module.exports = __webpack_public_path__ + "static/media/img_payment@2x.67f99280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_payment@2x.png
// module id = 1063
// module chunks = 0